<template>
	<div class="container" v-if="!codeShow">
		<div class="fill_top" v-if="ticketorder.status==5||ticketorder.status==3||ticketorder.status==6||ticketorder.status==1">
			<canvas id="canvas" ref="canva" style="display:none"></canvas>
			<img v-if="ticketorder.status==5" class="canvas_examine" src="../assets/canvas_img.png" />
			<img v-if="ticketorder.status==3" class="canvas_examine" src="../assets/quxiao.png" />
			<img v-if="ticketorder.status==6" class="canvas_examine" src="../assets/jujue.png" />
			<img v-show="!codeShow" v-if="ticketorder.status==1" class="canvas_img" :src="imgUrl" />
			<div v-show="!codeShow" v-if="ticketorder.status==1" class="code_text">扫码取票</div>
			<div class="fill_top_head">
				<div class="fill_top_head_photo">
					<img :src="ticketActivity.imageurl" />
				</div>
				<div class="fill_top_head_text">
					<p>北京香山革命纪念馆({{ordertype}})</p>
					<div>
						<p><span>{{ticketorder.appointment_time}}</span></p>
						<p>{{paragraphname}}</p>
					</div>
					<div v-if="teaminfo">
						<p>单位：<span>{{teaminfo.unit}}</span></p>
						<p v-if="teaminfo.depart!=''">部门：<span>{{teaminfo.depart}}</span></p>
					</div>
					<div v-if="!teaminfo">
						<p>预约成功：<span>{{ticketorder.successnum}}</span>人</p>
						<p>预约失败：<span>{{ticketorder.errornum}}</span>人</p>
					</div>
				</div>
			</div>
			<div class="fill_top_bottom">
				<div class="fill_address">{{ticketActivity.address}}</div>
				<div class="fill_Location">
					<img src="../assets/location.png" />
				</div>
			</div>
		</div>
		<div class="fill_top_top" v-if="ticketorder.status!=5&&ticketorder.status!=3&&ticketorder.status!=6&&ticketorder.status!=1">
			<canvas id="canvas" ref="canva" style="display:none"></canvas>
			<img v-if="ticketorder.status==5" class="canvas_examine" src="../assets/canvas_img.png" />
			<img v-if="ticketorder.status==3" class="canvas_examine" src="../assets/quxiao.png" />
			<img v-if="ticketorder.status==6" class="canvas_examine" src="../assets/jujue.png" />
			<img v-show="!codeShow" v-if="ticketorder.status==1" class="canvas_img" :src="imgUrl" />
			<div v-show="!codeShow" v-if="ticketorder.status==1" class="code_text">扫码取票</div>
			<div class="fill_top_head">
				<div class="fill_top_head_photo">
					<img :src="ticketActivity.imageurl" />
				</div>
				<div class="fill_top_head_text">
					<p>北京香山革命纪念馆({{ordertype}})</p>
					<div>
						<p><span>{{ticketorder.appointment_time}}</span></p>
						<p>{{paragraphname}}</p>
					</div>
					<div v-if="teaminfo">
						<p>单位：<span>{{teaminfo.unit}}</span></p>
						<p v-if="teaminfo.depart!=''">部门：<span>{{teaminfo.depart}}</span></p>
					</div>
					<div v-if="!teaminfo">
						<p>预约成功：<span>{{ticketorder.successnum}}</span>人</p>
						<p>预约失败：<span>{{ticketorder.errornum}}</span>人</p>
					</div>
				</div>
			</div>
			<div class="fill_top_bottom">
				<div class="fill_address">{{ticketActivity.address}}</div>
				<div class="fill_Location">
					<img src="../assets/location.png" />
				</div>
			</div>
		</div>
		<div class="personnel_information">
			<p v-if="teaminfo">领队人信息</p>
			<p v-if="!teaminfo">参观人员信息</p>
			<ul v-if="!teaminfo" class="information">
				<li v-for="(item,index) in ticketcodelist" v-show="index<num">
					<div class="information_left">
						<p>{{ticketcodelist[index].realname}}</p>
						<p v-if="!item.childnum" v-show="ordertype=='个人票'">携带儿童数：0</p>
						<p v-if="item.childnum" v-show="ordertype=='个人票'">携带儿童数：{{ticketcodelist[index].childnum}}</p>
						<div class="information_tips" v-if="ticketcodelist[index].status==0">
							<div><img src="../assets/success_no.png" /></div>
							<div>未激活</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==1">
							<div><img src="../assets/success_yes.png" /></div>
							<div>可使用</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==2">
							<div><img src="../assets/success_yes.png" /></div>
							<div>已完成</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==3">
							<div><img src="../assets/success_no.png" /></div>
							<div>已退票</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==4">
							<div><img src="../assets/success_no.png" /></div>
							<div>已过期</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==5">
							<div><img src="../assets/success_no.png" /></div>
							<div>待审核</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==6">
							<div><img src="../assets/success_no.png" /></div>
							<div>审核未通过</div>
						</div>
						<div v-if="ticketcodelist[index].takestatus==1" class="ticketcollection">未取票</div>
						<div v-if="ticketcodelist[index].takestatus==2" class="ticketcollection">已取票</div>
						<div class="ticketcollection_bottom">
							<p>{{ticketcodelist[index].idcard}}</p>
							<div @click="quxiao(item.tcid)" class="ticketcollection" v-show="holder==1&&item.status==1">取消</div>
						</div>
					</div>
				</li>
			</ul>
			<div v-if="!teaminfo" class="success_more" v-show="success_more" @click="toBottom">
				<img v-if="toTop_toBot" src="../assets/toBottom.png" />
				<img v-else src="../assets/toTop.png" />
			</div>
			<div v-if="teaminfo" class="informationMan">
				<div>姓名：{{teaminfo.contacts}}</div>
				<div>手机号：{{teaminfo.phone}}</div>
				<div>人数：{{teaminfo.ticketnum}}</div>
			</div>
		</div>
		<div class="appointment_time">
			<p>预约时间</p>
			<p>{{ticketorder.appointment_time }}</p>
		</div>
		<div class="appointment_file" v-if="ticketorder.commentlist">
			<p>观后感</p>
			<div class="appointment_file_list" v-for="item in ticketorder.commentlist">
				<div class="appointment_file_list_top">
					<div>{{item.nickname}}</div>
					<div>{{item.createtime}}</div>
				</div>
				<div class="appointment_file_list_content">{{item.comment_content}}</div>
				<div class="appointment_file_list_img">
					<img :src="i.imageurl" v-for="i in item.url">
				</div>
			</div>
		</div>
	</div>
	<div class="container" v-else="">
		<div class="fill_top" v-if="ticketorder.status==5||ticketorder.status==3||ticketorder.status==6">
			<canvas id="canvas" ref="canva" style="display:none"></canvas>
			<img v-if="ticketorder.status==5" class="canvas_examine" src="../assets/canvas_img.png" />
			<img v-if="ticketorder.status==3" class="canvas_examine" src="../assets/quxiao.png" />
			<img v-if="ticketorder.status==6" class="canvas_examine" src="../assets/jujue.png" />
			<div class="fill_top_head">
				<div class="fill_top_head_photo">
					<img :src="ticketActivity.imageurl" />
				</div>
				<div class="fill_top_head_text">
					<p>北京香山革命纪念馆({{ordertype}})</p>
					<div>
						<p><span>{{ticketorder.appointment_time}}</span></p>
						<p>{{paragraphname}}</p>
					</div>
					<div v-if="teaminfo">
						<p>单位：<span>{{teaminfo.unit}}</span></p>
						<p v-if="teaminfo.depart!=''">部门：<span>{{teaminfo.depart}}</span></p>
					</div>
					<div v-if="!teaminfo">
						<p>预约成功：<span>{{ticketorder.successnum}}</span>人</p>
						<p>预约失败：<span>{{ticketorder.errornum}}</span>人</p>
					</div>
				</div>
			</div>
			<div class="fill_top_bottom">
				<div class="fill_address">{{ticketActivity.address}}</div>
				<div class="fill_Location">
					<img src="../assets/location.png" />
				</div>
			</div>
		</div>
		<div class="fill_top_top" v-if="ticketorder.status!=5&&ticketorder.status!=3&&ticketorder.status!=6">
			<canvas id="canvas" ref="canva" style="display:none"></canvas>
			<img v-if="ticketorder.status==5" class="canvas_examine" src="../assets/canvas_img.png" />
			<img v-if="ticketorder.status==3" class="canvas_examine" src="../assets/quxiao.png" />
			<img v-if="ticketorder.status==6" class="canvas_examine" src="../assets/jujue.png" />
			<div class="fill_top_head">
				<div class="fill_top_head_photo">
					<img :src="ticketActivity.imageurl" />
				</div>
				<div class="fill_top_head_text">
					<p>北京香山革命纪念馆({{ordertype}})</p>
					<div>
						<p><span>{{ticketorder.appointment_time}}</span></p>
						<p>{{paragraphname}}</p>
					</div>
					<div v-if="teaminfo">
						<p>单位：<span>{{teaminfo.unit}}</span></p>
						<p v-if="teaminfo.depart!=''">部门：<span>{{teaminfo.depart}}</span></p>
					</div>
					<div v-if="!teaminfo">
						<p>预约成功：<span>{{ticketorder.successnum}}</span>人</p>
						<p>预约失败：<span>{{ticketorder.errornum}}</span>人</p>
					</div>
				</div>
			</div>
			<div class="fill_top_bottom">
				<div class="fill_address">{{ticketActivity.address}}</div>
				<div class="fill_Location">
					<img src="../assets/location.png" />
				</div>
			</div>
		</div>
		<div class="personnel_information">
			<p v-if="teaminfo">领队人信息</p>
			<p v-if="!teaminfo">参观人员信息</p>
			<ul v-if="!teaminfo" class="information">
				<li v-for="(item,index) in ticketcodelist" v-show="index<num">
					<div class="information_left">
						<p>{{ticketcodelist[index].realname}}</p>
						<p v-if="!item.childnum" v-show="ordertype=='个人票'">携带儿童数：0</p>
						<p v-if="item.childnum" v-show="ordertype=='个人票'">携带儿童数：{{ticketcodelist[index].childnum}}</p>
						<div class="information_tips" v-if="ticketcodelist[index].status==0">
							<div><img src="../assets/success_no.png" /></div>
							<div>未激活</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==1">
							<div><img src="../assets/success_yes.png" /></div>
							<div>可使用</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==2">
							<div><img src="../assets/success_yes.png" /></div>
							<div>已完成</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==3">
							<div><img src="../assets/success_no.png" /></div>
							<div>已退票</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==4">
							<div><img src="../assets/success_no.png" /></div>
							<div>已过期</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==5">
							<div><img src="../assets/success_no.png" /></div>
							<div>待审核</div>
						</div>
						<div class="information_tips" v-if="ticketcodelist[index].status==6">
							<div><img src="../assets/success_no.png" /></div>
							<div>审核未通过</div>
						</div>
						<div v-if="ticketcodelist[index].takestatus==1" class="ticketcollection">未取票</div>
						<div v-if="ticketcodelist[index].takestatus==2" class="ticketcollection">已取票</div>
						<div class="ticketcollection_bottom">
							<p>{{ticketcodelist[index].idcard}}</p>
							<div @click="quxiao(item.tcid)" class="ticketcollection" v-show="holder==1&&item.status==1">取消</div>
						</div>
					</div>
				</li>
			</ul>
			<div v-if="!teaminfo" class="success_more" v-show="success_more" @click="toBottom">
				<img v-if="toTop_toBot" src="../assets/toBottom.png" />
				<img v-else src="../assets/toTop.png" />
			</div>
			<div v-if="teaminfo" class="informationMan">
				<div>姓名：{{teaminfo.contacts}}</div>
				<div>手机号：{{teaminfo.phone}}</div>
				<div>人数：{{teaminfo.ticketnum}}</div>
			</div>
		</div>
		<div class="appointment_time">
			<p>预约时间</p>
			<p>{{ticketorder.appointment_time }}</p>
		</div>
		<div class="appointment_file" v-if="ticketorder.commentlist">
			<p>观后感</p>
			<div class="appointment_file_list" v-for="item in ticketorder.commentlist">
				<div class="appointment_file_list_top">
					<div>{{item.nickname}}</div>
					<div>{{item.createtime}}</div>
				</div>
				<div class="appointment_file_list_content">{{item.comment_content}}</div>
				<div class="appointment_file_list_img">
					<img :src="i.imageurl" v-for="i in item.url">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	import QRCode from 'qrcode'
	export default {
		name: 'AppointmentDetails',
		data() {
			return {
				ticketActivity: [],
				ticketorder: [],
				ticketcodelist: [],
				num: 2,
				isShow: true,
				success_more: true,
				toTop_toBot: true,
				baseUrl: "",
				orderid: "",
				ordertype: "",
				imgUrl: "",
				codeShow: true,
				idcardNum: 0,
				paragraphname: "",
				teaminfo: '',
				holder:""
			}
		},
		components: {
			QRCode: QRCode
		},
		methods: {
			quxiao(id){
				var that=this;
				sessionStorage.setItem('tcid',id)
				that.$router.push({
					name: "CancelReservation"
				})
			},
			useqrcode() {
				var that = this;
				let canvas = that.$refs.canva;
				var qrcode = 'orderid=' + that.orderid;
				QRCode.toCanvas(canvas, qrcode, function(error) {
					if(error) console.error(error)
				});
				that.imgUrl = canvas.toDataURL('image/png');
			},
			toBottom() {
				var that = this;
				that.isShow = !that.isShow;
				that.num = that.isShow ? 2 : that.ticketcodelist.length;
				if(that.isShow == false) {
					that.toTop_toBot = false;
				} else {
					that.toTop_toBot = true;
				}
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
					var baseUrl = "https://www.xiangshan1949.cn";
				that.codeShow = false
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.codeShow = false
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.codeShow = true
			}
			that.baseUrl = baseUrl;
			wclient.view.showLoading();
			that.orderid = sessionStorage.getItem("orderid");
			that.holder = sessionStorage.getItem("holder");
			$.ajax({
				type: "get",
				url: that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticketorder&action=ticketorderinfo&orderid=' + that.orderid,
				async: true,
				dataType: 'jsonp',
				crossDomain: true,
				xhrFields: {
					withCredentials: true
				},
				success: function(res) {
					wclient.view.hideLoading();
//					for(var i = 0; i < res.ticketcodelist.length; i++) {
//						if(res.ticketcodelist[i].certificate_type == 'idcard') {
//							that.idcardNum += 1
//						}
//					}
//					if(that.idcardNum == res.ticketcodelist.length) {
//						that.codeShow = false
//					} else {
//						that.codeShow = true
//					}
					that.ticketActivity = res.ticketActivity;
					that.ticketorder = res.ticketorder;
					that.ticketcodelist = res.ticketcodelist;
					// that.paragraphname = res.ticketorder.paragraphname
					if(res.ticketorder.paragraphid=='7a20e24c64724601af7bd7a656fe56db'){
						that.paragraphname = '上午'
					}else if(res.ticketorder.paragraphid=='9a81ca2d40374642b29321438d610432'){
						that.paragraphname = '下午'
					}else if(res.ticketorder.paragraphid=='8fa02b6e5a45459e8356f66c9869164e'){
						that.paragraphname = '上午'
					}else if(res.ticketorder.paragraphid=='52ce14988c354b949b39306a1aac8850'){
						that.paragraphname = '下午'
					}
					that.teaminfo = res.ticketorder.teaminfo;
					if(that.ticketorder.ordertype == 0) {
						that.ordertype = '个人票'
					} else if(that.ticketorder.ordertype == 1) {
						that.ordertype = '事业单位票'
					} else if(that.ticketorder.ordertype == 2) {
						that.ordertype = '企业单位票'
					} else if(that.ticketorder.ordertype == 3) {
						that.ordertype = '学校票'
					} else if(that.ticketorder.ordertype == 4) {
						that.ordertype = '政府机关票'
					} else if(that.ticketorder.ordertype == 5) {
						that.ordertype = '团体票'
					} else if(that.ticketorder.ordertype == 6) {
						that.ordertype = '电话预约票'
					} else if(that.ticketorder.ordertype == 7) {
						that.ordertype = '特殊团体票'
					}
					if(that.ticketcodelist.length < 3) {
						that.success_more = false;
					}
					that.useqrcode();
				}
			});
		}
	}
</script>

<style scoped>
	.container {
		float: left;
		width: 92%;
		display: block;
		padding: 0 4%;
		-webkit-overflow-scrolling: touch;
	}
	
	.fill_top {
		width: 90%;
		float: left;
		background: url(../assets/details.png) center center no-repeat;
		background-size: 100% 100%;
		padding: 5%;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	
	.fill_top_top {
		width: 90%;
		float: left;
		background: url(../assets/fill_top.png) center center no-repeat;
		background-size: 100% 100%;
		padding: 5%;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	
	.code_text {
		width: 100%;
		float: left;
		text-align: center;
		font-size: 15px;
		line-height: 50px;
		color: rgba(123, 123, 123, 1);
	}
	
	.fill_top_head {
		float: left;
		width: 100%;
		margin-bottom: 35px;
	}
	
	.canvas_img {
		width: 40%;
		margin: 0 auto;
	}
	
	.canvas_examine {
		width: 40%;
		margin: 40px auto;
	}
	
	.fill_top_head_photo {
		float: left;
		width: 70px;
		height: 70px;
		background: black;
		margin-right: 5%;
		border-radius: 10px;
		overflow: hidden;
	}
	
	.fill_top_head_text {
		float: left;
		width: 68%;
	}
	
	.fill_top_head_text>p {
		width: 100%;
		color: #919CA2;
		font-size: 12px;
		color: black;
		font-weight: 600;
		font-size: 12px;
		margin-top: 4px;
	}
	
	.fill_top_head_text>div {
		float: left;
		width: 100%;
		display: flex;
		justify-content: flex-start;
	}
	
	.fill_top_head_text>div p {
		width: 49%;
		font-size: 12px;
		color: #919CA2;
		margin-top: 5px;
	}
	
	.fill_top_bottom {
		width: 100%;
		float: left;
		display: flex;
		justify-content: space-between;
		margin-bottom: -5px;
	}
	
	.fill_address {
		font-size: 13px;
		color: rgba(108, 108, 108, 1);
	}
	
	.fill_Location {
		width: 5%;
	}
	
	.personnel_information {
		float: left;
		width: 90%;
		padding: 10px 5%;
		background: white;
		border-radius: 10px;
		margin-bottom: 10px;
	}
	
	.personnel_information>p {
		width: 100%;
		float: left;
		font-size: 16px;
		font-weight: 600;
	}
	
	.information {
		width: 100%;
		float: left;
	}
	
	.informationMan {
		width: 100%;
		float: left;
	}
	
	.informationMan div {
		width: 100%;
		font-size: 14px;
		color: #919CA2;
		margin-top: 10px;
	}
	
	.information li {
		float: left;
		width: 100%;
		height: 70px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-top: 1px solid #eee;
	}
	
	.information li:nth-child(1) {
		border-top: none;
	}
	
	.information_left {
		color: rgba(180, 180, 180, 1);
		font-size: 14px;
		width: 100%;
	}
	
	.information_left p:nth-of-type(1) {
		float: left;
		color: #585858;
		font-size: 14px;
		font-weight: 500;
		margin-right: 15px;
	}
	
	.information_left p:nth-of-type(2) {
		float: left;
		color: #585858;
		font-size: 14px;
		font-weight: 500;
		margin-right: 15px;
	}
	
	.information_left p:nth-of-type(3) {
		width: 80%;
		float: left;
	}
	
	.information_tips {
		float: left;
	}
	
	.ticketcollection {
		float: right;
		font-weight: 400;
		color: rgba(161, 168, 172, 1);
		font-size: 12px;
		border: 1px solid rgba(194, 194, 194, 1);
		border-radius: 20px;
		width: 16%;
		text-align: center;
		line-height: 20px;
	}
	
	.information_tips>div:nth-of-type(1) {
		float: left;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		margin-top: 4px;
		margin-right: 5px;
	}
	
	.information_tips>div:nth-of-type(2) {
		float: left;
		font-size: 12px;
		color: #474747;
		line-height: 20px;
	}
	
	.success_more {
		width: 100%;
		float: left;
		margin-bottom: 8px;
		margin-top: 8px;
	}
	
	.success_more img {
		width: 4%;
		margin: 0 auto;
	}
	
	.appointment_time {
		float: left;
		width: 90%;
		padding: 10px 5%;
		background: white;
		border-radius: 10px;
		margin-bottom: 10px;
	}
	
	.appointment_file {
		float: left;
		width: 90%;
		padding: 10px 5%;
		background: white;
		border-radius: 10px;
		margin-bottom: 10px;
	}
	
	.appointment_time>p:nth-of-type(1) {
		width: 100%;
		float: left;
		font-size: 16px;
		font-weight: 600;
	}
	
	.appointment_time>p:nth-of-type(2) {
		width: 100%;
		float: left;
		font-size: 14px;
		line-height: 50px;
		color: rgba(177, 177, 177, 1);
		letter-spacing: 1px;
	}
	
	canvas {
		display: block;
		margin: 0 auto;
		width: 180px;
		height: 180px;
	}
	
	.appointment_file_list {
		width: 100%;
		border-bottom: 1px solid rgba(243, 243, 243, 1);
		padding: 10px 0;
	}
	
	.appointment_file_list:last-child {
		border-bottom: 0;
	}
	
	.appointment_file_list_top {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		color: #B1B1B1;
	}
	
	.appointment_file_list_top div:nth-child(1) {
		font-size: 16px;
		margin-right: 20px;
	}
	
	.appointment_file_list_top div:nth-child(2) {
		font-size: 14px;
	}
	
	.appointment_file_list_content {
		width: 100%;
		color: #B1B1B1;
	}
	
	.appointment_file_list_img {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	
	.appointment_file_list_img img {
		width: 30%;
		border-radius: 5px;
		margin-right: 3%;
		margin-top: 10px;
	}
	.ticketcollection_bottom{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 30px;
		margin-top: 10px;
	}
	p{
		margin-bottom: 0px;
	}
</style>


// WEBPACK FOOTER //
// src/components/appointment_details.vue